import { BorderColor, Delete, Visibility, Settings } from '@mui/icons-material';
import { Button, ButtonGroup, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid, Link, Tooltip } from '@mui/material';
import { DataGrid, GridCellParams, GridColDef } from '@mui/x-data-grid';
import axios from 'axios';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import useSnackbarAlert from '../../../utils/snackbarHandlers';

const ShopListRenderer: React.FC<any> = () => {
    //@ts-ignore
    const config = window.config;
    const apiBaseURL = config?.server || 'http://18.217.95.31:8080';
    const { showErrorMessage, showSuccessMessage } = useSnackbarAlert();
    const { t } = useTranslation('translation');
    const [data, setData] = React.useState<Array<any>>([]);
    const [loading, setLoading] = React.useState<boolean>(false);
    const [totalCount, setTotalCount] = React.useState<number>(0);
    const [refreshTable, setRefreshTable] = React.useState<number>(0);
    const [dialogBox, setDialogBox] = React.useState(false);
    const [deleteId, setDeleteId] = React.useState();
    const navigate = useNavigate();
    const [paginationModel, setPaginationModel] = React.useState({
        page: 0,
        pageSize: 10,
    });

    const payload = {
        pageSize: paginationModel.pageSize,
        pageNumber: paginationModel.page + 1,
    };

    React.useEffect(() => {
        setLoading(true);
        axios.post(`${apiBaseURL}/api/shop/fetchShops`, payload)
            .then((res: any) => {
                setData(res?.data?.shops)
                setTotalCount(res?.data?.totalRecords)
            })
            .catch((error: Error) => {
                console.log("err", error)
            })
            .finally(() => setLoading(false));
    }, [paginationModel, refreshTable]);

    //need to change lastUpdatedBy value with loggedin User once localstorage is set
    const handleDelete = React.useCallback((id: any) => {
        axios.put(`${apiBaseURL}/api/shop/updateShop?id=${id}`, { isActive: false, lastUpdatedBy: "Bhavesh" })
            .then((res: any) => {
                setDialogBox(false);
                setRefreshTable(Math.random());
                showSuccessMessage(t("deletedShopSuccessMessage"));
            })
            .catch((error: Error) => {
                showErrorMessage(error)
            })
    }, []);

    const handleCloseDialogbox = () => {
        setDialogBox(false);
    };

    const fetchSubscriptionDetails = async (id: any) => {
        axios.get(`${apiBaseURL}/api/subscription/fetchShopSubscriptionDetails?id=${id}`).then(async (response: any) => {
            await localStorage.setItem("subscription", JSON.stringify(response?.data?.subscription));
            navigate(`/admin/setting/${id}`);
        });
    }

    const columns: GridColDef[] = [
        {
            field: 'fullName',
            headerName: 'Shop name',
            width: 200,
            align: "center",
            headerAlign: "center",
            flex: 1,
        },
        {
            field: 'address',
            headerName: 'Address',
            width: 200,
            align: "center",
            headerAlign: "center",
            flex: 1,
        },
        {
            field: 'email',
            headerName: 'Email',
            width: 200,
            align: "center",
            headerAlign: "center",
            flex: 1,
        },
        {
            field: 'createdAt',
            headerName: 'Date',
            width: 200,
            align: "center",
            headerAlign: "center",
            flex: 1,
            valueFormatter: (params: any) => {
                const creationDate = params.value;
                // return (
                //     (creationDate?.split("T")[0] as string) +
                //     " " +
                //     (creationDate?.split("T")[1] as string)?.slice(0, 8)
                // );
                const date = creationDate?.split("T")[0];
                const splittedDate = date.split("-");
                const formattedDate = `${splittedDate[1]}-${splittedDate[2]}-${splittedDate[0]}`;
                return formattedDate;
            },
        },
        {
            field: 'phone',
            headerName: 'Phone',
            width: 200,
            align: "center",
            headerAlign: "center",
            flex: 1,
        },
        {
            field: 'paymentStatus',
            headerName: 'Payment Status',
            width: 200,
            align: "center",
            headerAlign: "center",
            flex: 1,
            renderCell: (params: GridCellParams) => {
                return (
                    <div className='flex'>
                        <div>{params?.value === "PAID" ? "Paid" : "Un-Paid"}</div>
                        <div className={`${params?.value === "PAID" ? "active-shop" : "inactive-shop"} ms-2 rounded-[50%] text-white w-[20px]`}></div>
                    </div>
                );
            },
        },
        {
            field: "actions",
            headerName: "Actions",
            sortable: false,
            filterable: false,
            align: "center",
            headerAlign: "center",
            width: 200,
            renderCell: (params: GridCellParams) => {
                return (
                    <ButtonGroup size="small" color="inherit" aria-label="group action buttons">
                        <Tooltip title="View">
                            <Button
                                onClick={(e) => navigate(`/admin/viewShop/${params?.id}`)}
                            >
                                <Visibility fontSize="small" />
                            </Button>
                        </Tooltip>
                        <Tooltip title="Edit">
                            <Button
                                onClick={(e) => navigate(`/admin/editShop/${params?.id}`)}
                            >
                                <BorderColor fontSize="small" />
                            </Button>
                        </Tooltip>
                        {params.row.status !== "DELETED" &&
                            (
                                <Tooltip title="Delete">
                                    <Button
                                        onClick={() => {
                                            setDialogBox(true);
                                            setDeleteId(params.row.uId);
                                        }}
                                    >
                                        <Delete fontSize="small" />
                                    </Button>
                                </Tooltip>
                            )}
                        <Tooltip title="Setting">
                            <Button
                                onClick={(e) => fetchSubscriptionDetails(params?.id)}
                            >
                                <Settings fontSize="small" />
                            </Button>
                        </Tooltip>
                    </ButtonGroup>
                );
            },
            flex: 1,
        },
    ];



    return (
        <>
            <Dialog
                open={dialogBox}
                onClose={handleCloseDialogbox}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {t('deleteShop')}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {t('deleteShopConfirmation')}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseDialogbox}>{t('disagree')}</Button>
                    <Button onClick={() => handleDelete(deleteId)} autoFocus>
                        {t('agree')}
                    </Button>
                </DialogActions>
            </Dialog>
            <Grid className="w-full" style={{
                marginTop: "1%",
                height: "630px",
            }}>
                <DataGrid
                    rows={data}
                    loading={loading}
                    columns={columns}
                    rowCount={totalCount}
                    pageSizeOptions={[10, 20, 50, 100]}
                    pagination
                    paginationMode="server"
                    paginationModel={paginationModel}
                    onPaginationModelChange={setPaginationModel}
                    getRowId={(row) => row.uId}
                    disableColumnSelector
                    disableRowSelectionOnClick
                    sx={{
                        '& .MuiDataGrid-main': {
                            borderColor: "#DAA520",
                        },
                        '& .MuiDataGrid-columnHeader': {
                            backgroundColor: "#F5F5E6",

                        },
                        '& .MuiDataGrid-columnHeaderTitle': {
                            fontWeight: 600,

                        },
                        '& .MuiDataGrid-row.Mui-odd': {
                            backgroundColor: "#F5F5E6",
                        }
                        // maxWidth: "fit-content",
                    }}
                    getRowClassName={(params) => {
                        return params.id as number % 2 === 0 ? 'Mui-even' : 'Mui-odd'
                    }
                    }
                    columnBuffer={0}
                // autoHeight

                />
            </Grid>
        </>
    );
}
export default ShopListRenderer;